<template>
  <div class="container">
    <div class="tab">
      <div :class="{ before: type == 1 }" @click="clickTab(1)">在途预报</div>
      <div :class="{ before: type == 2 }" @click="clickTab(2)">现车情况</div>
    </div>
    <div class="content">
      <dv-scroll-board :config="config" style="height: 300px" @mouseover="mouseover" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList:{
      type:Array,
      default: function () {
        return [];
      },
    },
    tbForecastOnWaysXC:{
      type:Array,
      default: function () {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      type: 1,
      config: {
        
      },
      ztyb:'',
      xcqk:''
    };
  },
  watch: {
    dataList(newVal, oldVal) {
      this.ztyb = newVal
      this.config = {
        header: ['客户名称', '货物品名', '车次','发站','到站','当前站'],
        data: newVal,
        // index: true,
        // columnWidth: [50, 170, 300],
        // align: ["center"],
        // rowNum: 5,
        headerBGC:'#274c74',
        headerHeight:50,
        oddRowBGC:'',
        evenRowBGC:'#143A74',
      };
    },
    tbForecastOnWaysXC(newVal, oldVal) {
      this.xcqk = newVal
    },
  },

  methods: {
    clickTab(e) {
      console.log(e)
      this.type = e;
      this.config = {}
      if(e == 1){
        this.config = {
          header: ['客户名称', '货物品名', '车次','发站','到站','当前站'],
          data: this.ztyb,
          // index: true,
          // columnWidth: [50, 170, 300],
          // align: ["center"],
          // rowNum: 5,
          headerBGC:'#274c74',
          headerHeight:50,
          oddRowBGC:'',
          evenRowBGC:'#143A74',
        };
      }else{
        this.config = {
          header: ['客户名称', '货物品名', '车次','发站','到站','当前站'],
          data: this.xcqk,
          // index: true,
          // columnWidth: [50, 170, 300],
          // align: ["center"],
          // rowNum: 5,
          headerBGC:'#274c74',
          headerHeight:50,
          oddRowBGC:'',
          evenRowBGC:'#143A74',
        };
      }
    },
    mouseover(config){
        console.log('config', config)
        console.log('ceil', config.ceil)
        console.log('hang', config.rowIndex)
    }
  },
};
</script>
<style scoped>
  /deep/.header-item{
    font-size: 22px;
  }
  /deep/.ceil{
    font-size: 20px;
  }
.container {
  width: 100%;
  height: 100%;
  background: url("~@/assets/images2/bg3.png") no-repeat;
  background-size: 100% 100%;
}
.tab {
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5% 3% 0%;
  box-sizing: border-box;
}
.tab div {
  font-size: 25px;
  color: white;
  position: relative;
  margin-right: 3%;
}
.content {
  padding: 0% 3%;
  margin-top: 0.5%;
}
.before::before {
  content: "";
  width: 100%;
  height: 4px;
  background: #7dc3ff;
  position: absolute;
  bottom: -33%;
  left: 0;
}
</style>
